import { render, staticRenderFns } from "./EmailAdmin.vue?vue&type=template&id=057a7fec&scoped=true&"
import script from "./EmailAdmin.vue?vue&type=script&lang=js&"
export * from "./EmailAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a7fec",
  null
  
)

export default component.exports